import { useQuery } from "@tanstack/react-query";
import { fetchEvaluationGroups } from "@/lib/api/resources/evaluationGroups";
import { evaluationGroupColumns } from "./lib/constants/evaluationGroupColumns";
import { Table } from "@/components/v2";

export const EvaluationGroupsList = () => {
  const evaluationGroupsQuery = useQuery({
    queryKey: ["evaluation-groups"],
    queryFn: fetchEvaluationGroups,
  });

  return (
    <div>
      <Table
        columns={evaluationGroupColumns}
        dataSource={evaluationGroupsQuery.data}
        loading={evaluationGroupsQuery.isLoading}
        pagination={false}
        rowKey="id"
      />
    </div>
  );
};
